import { Route, Routes, ScrollToTop } from '@thd-olt-component-react/router';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useEffect } from 'react';
import Spinner from './components/shared/Spinner';
import CommonProvider from './contexts/CommonContext';
import { OrderDetialsProvider } from './contexts/OrderDetailsContext';
import { SearchResultsProvider } from './contexts/SearchResults';
import { PurchaseHistoryProvider } from './contexts/PurchaseHistoryContext';
import { useAppContext } from './hooks/useContexts';
import { Error } from './pages';
import { getRoutes } from './routes.js';
import './styles/app.scss';
import { redirectGuestOrderTracking, redirecToErrorPage, redirectToSignIn, } from './utils/http-helper';
import { OrderProvider } from './contexts/OrderContext';
export var App = function (_a) {
    var customerType = _a.customerType, customerRole = _a.customerRole;
    var instance = useAppContext().instance;
    var _b = useThdCustomer(), isLoggedIn = _b.isLoggedIn, isB2CCustomer = _b.isB2CCustomer;
    var _c = instance.router, currentRouteName = _c.currentRouteName, currentRouteComponent = _c.currentRouteComponent;
    var routes = getRoutes(currentRouteName, currentRouteComponent);
    // Flag that stops redirect to login for selected pages.
    var routeToSigninExemptFlag = ['home', 'guestOrderTracking'].includes(currentRouteName);
    var routeCancelItems = ['cancelItems'].includes(currentRouteName);
    useEffect(function () {
        if (!isLoggedIn && routeCancelItems) {
            redirectGuestOrderTracking();
            return;
        }
        // Check's if user is logged in and has the svoc and user Id's
        if (!isLoggedIn && !routeToSigninExemptFlag) {
            redirectToSignIn();
        }
        // Checks if user is b2c and if requested page is a b2b only page
        if (isB2CCustomer &&
            ['business-tools', 'linked-accounts', 'downloads'].includes(currentRouteName)) {
            redirecToErrorPage();
        }
    }, [currentRouteName]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ScrollToTop, null),
        React.createElement(CommonProvider, null,
            React.createElement(React.Fragment, null,
                React.createElement(Routes, null,
                    React.createElement(Route, { exact: true, path: routes.purchaseHistory.path, element: React.createElement(PurchaseHistoryProvider, { customerRole: customerRole, customerType: customerType },
                            React.createElement(routes.purchaseHistory.component, { customerType: customerType, customerRole: customerRole })) }),
                    React.createElement(Route, { exact: true, path: routes.orderDetails.path, element: React.createElement(OrderProvider, null,
                            React.createElement(OrderDetialsProvider, { customerRole: customerRole, customerType: customerType },
                                React.createElement(routes.orderDetails.component, { customerType: customerType, customerRole: customerRole }))) }),
                    React.createElement(Route, { exact: true, path: routes.cancelItems.path, element: React.createElement(routes.cancelItems.component, { customerType: customerType, customerRole: customerRole }) }),
                    React.createElement(Route, { exact: true, path: routes.linkedAccounts.path, element: React.createElement(routes.linkedAccounts.component, { customerType: customerType, customerRole: customerRole }) }),
                    React.createElement(Route, { exact: true, path: routes.downloads.path, element: React.createElement(routes.downloads.component, { customerType: customerType, customerRole: customerRole }) }),
                    React.createElement(Route, { exact: true, path: routes.businessTools.path, element: React.createElement(routes.businessTools.component, { customerType: customerType, customerRole: customerRole }) }),
                    React.createElement(Route, { exact: true, path: routes.subscriptions.path, element: React.createElement(routes.subscriptions.component, { customerType: customerType, customerRole: customerRole }) }),
                    React.createElement(Route, { exact: true, path: routes.guestOrderTracking.path, element: React.createElement(routes.guestOrderTracking.component, { customerType: customerType, customerRole: customerRole }) }),
                    React.createElement(Route, { exact: true, path: routes.searchResults.path, element: React.createElement(SearchResultsProvider, null,
                            React.createElement(routes.searchResults.component, { customerType: customerType, customerRole: customerRole })) }),
                    React.createElement(Route, { exact: true, path: routes.home.path, element: React.createElement(routes.home.component, null) }),
                    React.createElement(Route, { path: "/error", element: React.createElement(Error, null) }),
                    React.createElement(Route, { element: React.createElement(Error, null) })),
                React.createElement(Spinner, null)))));
};
App.propTypes = {};
App.defaultProps = {};
